<template>
    <v-dialog max-width="800px" v-model="cDialog" persistent>
        <v-card>
            <v-card-title>
                <div class="headline"
                     style="text-align: center;text-transform:uppercase;width: 100%;border-bottom: 0px solid gray; height:0px">
                    <v-btn @click="onCancel" icon style="float: right">
                        <v-icon>cancel</v-icon>
                    </v-btn>

                </div>
            </v-card-title>
            <v-card-text>
                <v-form>
                    <v-container>
                        <v-card>
                            <v-toolbar color="primary" dark>
                                <v-toolbar-title style="padding-left: 10px">{{$t('lang.customer.customerGeneral')}}
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-layout wrap class="viewInfo">
                                <v-flex xs6 style="padding: 10px">
                                    <div class="form-group">
                                        <label class="label">{{$t(customerName)}}: </label>
                                        <label class="text">{{item.customer.customerName}}</label>
                                    </div>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <div class="form-group">
                                        <label class="label">{{$t(customerEmail)}}: </label>
                                        <label class="text">{{item.customer.email}}</label>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-text>
                <v-form ref="viewPresentForm">
                    <c-search-form :input-search-items="searchItems"
                                   :hidden-search-items="hiddenSearchItems"
                                   :customer-id="customerId"
                                   :rows-per-page-items="[10,20,50]"
                                   :input-create-items="createItems"
                                   :form-name="formName" :create-form-name="createFormName"
                                   model="searchForm" :fields="fields" accept-delete
                                   key-property="customerDocumentId"
                                   search-url="/customerDocument/search"
                                   create-url="/customerDocument/save"
                                   delete-url="/customerDocument/delete"
                                   ref="s1"
                    >
                        <v-btn slot="feartureBtn" color="error" @click="onCancel">
                            <v-icon dark left>cancel</v-icon>
                            {{$t('lang.common.back')}}
                        </v-btn>
                        <customer-document-create id="createDiv2" slot="createForm"
                                                  :create-form-name="createFormName"
                                                  style="display: none" @close="hideCreateForm2"
                                                  create-url="/customerDocument/save" ref="s2"/>

                    </c-search-form>
                </v-form>


            </v-card-text>

        </v-card>
    </v-dialog>

</template>

<script>
    import CSearchForm from "../../../../components/form/ListForm2";
    import CustomerDocumentCreate from "./CustomerDocumentCreate";
    import axios from "axios";

    export default {
        name: 'customer-document',
        components: {CSearchForm, CustomerDocumentCreate},
        props: {
            customerId: {
                type: Number,
                default: -1,
            },
            cDialog: {
                type: Boolean,
                default: false,
            }
        },
        data: () => {
            return {
                formName: "lang.customerDocument.formName",
                createFormName: "lang.customerDocument.createformName",
                customerName: "lang.customer.customerName",
                customerEmail: "lang.customer.email",
                subjects: [],
                createDiv: false,
                searchDiv: false,
                item: {
                    customer: {
                        email: null,
                        customerName: null
                    }
                },

                searchItems: [
                    {
                        type: "text",
                        name: "documentCode",
                        label: "lang.customerDocument.documentCode",
                        placeHolder: "",
                        focus: true
                    }
                    ,
                    {
                        type: "text",
                        name: "documentName",
                        label: "lang.customerDocument.documentName",
                        placeHolder: ""
                    }
                ],
                hiddenSearchItems:
                    {
                        type: "text",
                        name: "customerId",
                    }
                ,
                createItems: [
                    {
                        type: "text",
                        name: "documentCode",
                        label: "lang.customerDocument.documentCode",
                        validate: "required",
                        maxlength: '50',
                        placeHolder: "",
                        errorText: "Lỗi"
                    },
                    {
                        type: "text",
                        name: "documentName",
                        label: "lang.customerDocument.documentName",
                        validate: "required",
                        maxlength: "500",
                        placeHolder: ""
                    }
                ],
                fields: [
                    {
                        value: "index",
                        text: "lang.common.index",
                        width: "5%",
                        sortable: false,
                        headerStyle: "text-align:center"
                    },
                    {
                        value: 'documentCode',
                        text: 'lang.customerDocument.documentCode',
                        width: "40%",
                        sortable: false,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'documentName',
                        text: 'lang.customerDocument.documentName',
                        width: "30%",
                        sortable: false,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'action',
                        text: 'lang.customer.action',
                        width: "25%",
                        sortable: false,
                        compound: true,
                        headerStyle: "text-align:left"
                    }
                ]
            }
        },
        watch: {
            customerId: function (value) {
                if (value != -1) {
                    this.hiddenSearchItems.value = value;
                    console.log("hiddenSearchItems", this.hiddenSearchItems.value);
                    //alert(this.hiddenSearchItems.value)
                    this.hideCreateForm2();

                    const formData = {customerId: value};
                    console.log("formData", formData);
                    axios.post(process.env.VUE_APP_API_URL + "/customerDeputy/searchOne", formData).then(
                        data => {
                            this.item = data;
                            console.log("data", data);

                            //this.$refs.viewPresentForm.reset();
                        }
                    )
                } else{
                    this.item = {customer:{
                            email: null,
                            customerName: null}}
                }
            }
        },
        methods: {
            copyValue: function (value) {
                let ob = {};
                for (let key in value) {
                    ob[key] = value[key];
                }
                return ob;
            },
            onCancel: function () {
                this.$emit("close", '');
            },


            hideCreateForm2: function () {

                try {
                    if (document.getElementById("searchDiv2") != null)
                        document.getElementById("searchDiv2").style.display = "";
                    if (document.getElementById("createDiv2") != null)
                        document.getElementById("createDiv2").style.display = "none";


                } catch (e) {
                    console.log(e);
                }
            },

            closeCreateDiv: function () {
                this.searchDiv = true;
                this.createDiv = false;
                this.pagination.page = 1;
                this.search();
            },

        },
        created() {

            if (this.$route.params.id) {
                this.hiddenSearchItems.value = this.$route.params.id;
                this.customerId = this.$route.params.id;
            }
        }
    }
</script>
